window.motivUi = window.motivUi || {};
motivUi.globals = motivUi.globals || {};
motivUi.globals.routing = motivUi.globals.routing || {};
motivUi.globals.routing.pathBase = motivUi.globals.routing.pathBase || '';

if (window.location.pathname.toLowerCase() != motivUi.globals.routing.pathBase.toLowerCase() + "/error") {
    window.onerror = function (msg, url, lineNo, columnNo, error) {
        function createInput(name, value) {
            var input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", name);
            input.value = value;
            return input;
        }

        if (msg == "Script error." && lineNo == 0 && columnNo == 0) {
            return true; // Don't log errors where details aren't available due to cross-origin restrictions
        }
        var form = document.createElement("form");
        form.setAttribute('method', "post");
        form.setAttribute('action', motivUi.globals.routing.pathBase + "/Error");
        form.appendChild(createInput("message", "JS: " + msg));
        form.appendChild(createInput("stackTrace", ((error && error.stack) || '') + ' at ' + url + ':' + lineNo + ':' + columnNo + ':' + window.location.pathname));
        if (document.getElementsByTagName('body').length == 0) {
            document.body = document.createElement("body");
        }
        document.getElementsByTagName('body')[0].appendChild(form);
        form.submit();
        return true;
    }
}